var _g, _g2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1122 1122",
    style: {
      "enableBackground": "new 0 0 1122 1122"
    },
    xmlSpace: "preserve"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bg"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Object"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st336",
    points: "874.69,837.34 247.31,837.35 561,284.65 \t\t\t"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st336",
    points: "247.31,837.35 561.41,659.03 874.69,837.34 561.13,659.72 561,284.65 \t\t\t"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st336",
    points: "717.85,565.07 561.14,474.6 404.44,565.07 404.44,746.02 561.14,836.49 717.85,746.02 \t\t\t"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st350",
    points: "520.25,658.84 561.51,506.4 602.88,659.1 561.51,811.81 \t\t\t\t"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st350",
    points: "561.51,617.83 714.6,658.84 561.51,700.12 407.69,658.84 \t\t\t\t"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st350",
    d: "M561.51,506.4l0,305.4L561.51,506.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st350",
    d: "M407.69,658.84l306.91,0L407.69,658.84z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st350",
    points: "540.73,638.33 637.89,582.42 581.66,679.27 \t\t\t\t"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st350",
    points: "581.66,679.27 484.4,735.78 540.73,638.33 \t\t\t\t"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st350",
    points: "484.4,582.42 540.48,679.52 484.4,582.42 581.91,638.58 \t\t\t\t"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st350",
    points: "540.48,679.51 637.88,735.79 581.93,638.58 637.88,735.79 \t\t\t\t"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st350",
    x1: 484.4,
    y1: 735.78,
    x2: 637.89,
    y2: 582.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "st350",
    x1: 484.4,
    y1: 582.42,
    x2: 637.88,
    y2: 735.79
  })))))));
};

export default __webpack_public_path__ + "static/media/signz.e9253390.svg";
export { SvgComponent as ReactComponent };